import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { fromEvent } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, switchMap, tap, filter } from 'rxjs/operators';

@Component({
  selector: 'autocomplete-chips-async',
  templateUrl: './autocomplete-chips-async.component.html',
  styleUrls: ['./autocomplete-chips-async.component.scss']
})
export class AutocompleteChipsAsyncComponent implements OnInit {
  @Input() control: FormControl;
  @Input() placeholder?: string = '';
  @Input() textLoading?: string = 'Chargement en cours';
  @Input() labelProperty?: string = 'label';
  @Input() valueProperty?: string = 'id';
  @Input() funcLoadData?: (term: string) => any[];
  @ViewChild('autocompleteInput', { static: true }) private autocompleteInput: ElementRef<HTMLInputElement>;
  public data = [];
  public loadingData = false;

  constructor() {
  }

  ngOnInit(): void {
    const $fetchDataOnInputKeyup = fromEvent(this.autocompleteInput.nativeElement, 'keyup').pipe(
      map(event => (event.target as HTMLInputElement).value),
      filter(term => term.length >= 2),
      debounceTime(500),
      distinctUntilChanged(),
      tap(() => { this.loadingData = true; this.data = []; }),
      switchMap(term => this.funcLoadData(term))
    );

    $fetchDataOnInputKeyup
      .subscribe((data) => {
        this.data = data;
        this.loadingData = false;
      });
  }

  public remove(index: number) {
    this.control.setValue(this.control.value.filter((el, i) => i !== index));
    this.control.updateValueAndValidity();
  }

  public onOptionSelected(selectedOption: MatAutocompleteSelectedEvent) {
    this.autocompleteInput.nativeElement.value = '';

    // D'abord vérifier que l'élément n'est pas déjà présent dans la liste actuelle, sinon il y aura doublon
    const id = selectedOption.option.value[this.valueProperty];

    for (const alreadySelectionOption of this.control.value) {
      if (alreadySelectionOption[this.valueProperty] === id) {
        return;
      }
    }

    this.control.setValue([...this.control.value, selectedOption.option.value]);
    this.control.updateValueAndValidity();
  }
}
